module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Search-513cc4113bc73161f797cd14b12d24d2.svg";